import { createStateSelectorHook } from 'src/lib/sweetState';

import { Store } from './store';

const useStoreState = createStateSelectorHook(Store, ['project', 'loading', 'error']);

export const useViewState = () => {
  const storeState = useStoreState();
  return { ...storeState };
};
